"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _GatewayService = _interopRequireDefault(require("../GatewayService.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var score = new _GatewayService["default"]('score-service');

var fetchScores = function fetchScores() {
  var userList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cardstackKey = arguments.length > 1 ? arguments[1] : undefined;

  if (_lodash["default"].isString(userList)) {
    userList = [userList];
  }

  var params = {
    appGroup1Id: cardstackKey
  };
  return score.post('api/0.2/score/find/curriculum', userList, {
    params: params
  });
};

var fetchScoresForCardstacks = function fetchScoresForCardstacks(userKeys, cardstackKeys) {
  var params = {
    userBusinessKeys: userKeys,
    appGroup1Ids: cardstackKeys
  };
  return score.post('api/0.2/score/batchfind/curriculum', params);
};

var saveScores = function saveScores(scoreEntries) {
  return score.post('api/0.2/score', scoreEntries);
};

var _default = {
  fetchScores: fetchScores,
  fetchScoresForCardstacks: fetchScoresForCardstacks,
  saveScores: saveScores
};
exports["default"] = _default;